import React, { useEffect, useState } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import PostIdea from '../../components/Post/PostIdea';
import PostIdeaBrief from '../../components/Post/PostIdeaBrief';
import PostList from '../../components/Post/SidePostList';
import SidePostGroup from '../../components/Post/SidePostGroup';
import '../../assets/post.css';
import '../../assets/common.css';
import Header from './Header';

const AIMeetingProPost = () => {
    const [data, setData] = useState([]);
    const [isClassActive, setIsExpanded] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    // 取得查詢字串
    const queryParams = new URLSearchParams(location.search);
    const ci = queryParams.get('ci');
    const id = queryParams.get('id');

    // 元件要大寫
    let Component;
    if (id !== '' && id !== null) {
        Component = PostIdea;
    } else {
        Component = PostIdeaBrief;
    }
    
    return (
        <>
        <Header /> 
        <div className="container content-wrapper" style={{marginTop: '100px'}}>
            <div className="row">
                <div className="col-lg-8">
                    <Component id={id} ci={ci}/>
                </div>
                <div className='col-lg-4'>
                    <SidePostGroup />
                    <PostList />
                </div>
            </div>
        </div>
        </>
    );
};

export default AIMeetingProPost;